import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  const getTypeStyle = (type: string) => {
    switch (type) {
      case '上新': return 'bg-accent-100 text-accent-700';
      case '更新': return 'bg-primary-100 text-primary-700';
      case '公告': return 'bg-secondary-200 text-secondary-700';
      case '专题': return 'bg-accent-100 text-accent-700';
      default: return 'bg-secondary-100 text-secondary-700';
    }
  };

  return (
    <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-extrabold text-foreground-900">最新动态</h2>
          <p className="text-sm text-foreground-600 mt-2">91视频网站每日内容更新与平台公告，不错过任何精彩</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300 hidden sm:block"></div>

          <div className="space-y-4">
            {updatesData.map((item) => (
              <div key={item.id} className="flex items-start gap-4">
                <div className="hidden sm:flex w-10 h-10 rounded-full bg-background-50 border-2 border-background-300 flex-shrink-0 items-center justify-center relative z-10">
                  <div className="w-2 h-2 rounded-full bg-primary-500"></div>
                </div>
                <div className="flex-1 bg-background-50 rounded-xl p-4 border border-background-200/70 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className="text-xs font-semibold text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className={`px-1.5 py-0.5 rounded text-xs font-medium whitespace-nowrap ${getTypeStyle(item.type)}`}>
                      {item.type}
                    </span>
                  </div>
                  <p className="text-sm font-medium text-foreground-900">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}